// extracted by mini-css-extract-plugin
export var card = "LocationCard-module--card--5c48d";
export var link = "LocationCard-module--link--93fa4";
export var picture = "LocationCard-module--picture--51e3c";
export var img = "LocationCard-module--img--bf1e6";
export var contentWrapper = "LocationCard-module--contentWrapper--7aefe";
export var title = "LocationCard-module--title--bd1a9";
export var details = "LocationCard-module--details--7a915";
export var date = "LocationCard-module--date--953bc";
export var dateIcon = "LocationCard-module--dateIcon--50547";
export var tag = "LocationCard-module--tag--1a03b";